import {replace} from 'ramda';

import {VARIABLE_REGEX} from './getVariables';

export {VARIABLE_REGEX};

// Pre-compile the RegExp to avoid creating it on each function call
// eslint-disable-next-line security/detect-non-literal-regexp
const compiledVariableRegex = new RegExp(VARIABLE_REGEX, 'g');

export const replaceVariables = (value: string, replaceValue = '____') =>
  replace(compiledVariableRegex, replaceValue, value);
